import { combineReducers } from "redux";
import memberreducer from "./member"
const rootReducer = combineReducers({memberreducer});

export default rootReducer;